import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
// tslint:disable-next-line: no-submodule-imports
import storage from "redux-persist/lib/storage";
import historyReducers from "./_core/history";
import notificationReducers from "./_core/notification";
import { jobGlobalReducer } from "./_core/job";
import authReducers from "./app/auth";
import vesselReducers from "./app/vessel";
import logReducers from "./app/logs";
import approvalReducers from "./app/approval";
import marpolReducers from "./app/marpol";
import extReducers from "./app/ext";
import checklistReducers from "./app/checklist/reducers";
import feedbackReducers from "./app/feedback/reducers";
import userReducers from "./app/user";
import topNavbarReducers from "./app/topnavbar";
import dashboardReducers from "./app/dashboard";
import reportReducers from "./app/report";
import toolReducers from "./app/tool";
import insightReducers from "./app/insight";
import grb2Reducers from "./app/grb2";
import vdmDashboardReducers from "./app/vdmdashboard";
import garbageRecordReducers from "./app/garbage-record";
import orb4Reducers from "./app/orb4";
import orb1Reducers from "./app/orb1";
import crbReducers from "./app/crb";
import bfl1Reducers from "./app/bfl-1";
import bfl2Reducers from "./app/bfl-2";
import annex6Reducers from "./app/annex6";
import ballastReducers from "./app/ballast";
import annex6V2Reducers from "./app/annex6-v2";
import orb3Reducers from "./app/orb3";

const appPersistConfig = {
	key: "app",
	storage,
	whitelist: ["auth"],
	debug: true,
};

const rootReducer = combineReducers({
	core: combineReducers({
		history: historyReducers,
		notification: notificationReducers,
		jobGlobal: jobGlobalReducer,
	}),
	app: persistReducer(
		appPersistConfig,
		combineReducers({
			auth: authReducers,
			vesselStore: vesselReducers,
			approvalStore: approvalReducers,
			checklistStore: checklistReducers,
			logs: logReducers,
			marpol: marpolReducers,
			extStore: extReducers,
			feedback: feedbackReducers,
			user: userReducers,
			topnavbar: topNavbarReducers,
			grb2: grb2Reducers,
			dashboard: dashboardReducers,
			garbageRecord: garbageRecordReducers,
			report: reportReducers,
			tool: toolReducers,
			insight: insightReducers,
			vdmDashboard: vdmDashboardReducers,
			orb1: orb1Reducers,
			orb4: orb4Reducers,
			orb3: orb3Reducers,
			crb: crbReducers,
			bfl1: bfl1Reducers,
			bfl2: bfl2Reducers,
			annex6: annex6Reducers,
			ballast: ballastReducers,
			annex6V2: annex6V2Reducers,
		}),
	),
});
export default rootReducer;
